import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

const KEY = "elan_cookie_consent";

export const getCookieConsent = () => {
  try { return JSON.parse(localStorage.getItem(KEY) || "null"); } catch { return null; }
};
export const hasAnalyticsConsent = () => !!getCookieConsent()?.analytics;

export const openCookieSettings = () => {
  localStorage.removeItem(KEY);
  window.dispatchEvent(new Event("elan-cookie-reopen"));
};

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(!getCookieConsent());
    const reopen = () => setVisible(true);
    window.addEventListener("elan-cookie-reopen", reopen);
    return () => window.removeEventListener("elan-cookie-reopen", reopen);
  }, []);

  const decide = (analytics) => {
    localStorage.setItem(KEY, JSON.stringify({ analytics, date: new Date().toISOString() }));
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[60] p-3 sm:p-5" data-testid="cookie-banner">
      <div className="max-w-4xl mx-auto bg-white/95 backdrop-blur-md border border-blush shadow-xl rounded-2xl p-4 sm:p-5">
        <div className="flex items-start gap-3">
          <Cookie size={20} className="text-deep-rose shrink-0 mt-0.5" />
          <div className="flex-1 min-w-0">
            <h2 className="font-serif-display text-base md:text-lg text-stone-800">Respect de votre vie privée</h2>
            <p className="text-sm text-stone-600 mt-1 leading-relaxed">
              Nous utilisons uniquement les cookies nécessaires au fonctionnement du site (connexion, paiement sécurisé).
              Avec votre accord, nous pourrons y ajouter une mesure d'audience anonyme pour améliorer le site. Aucune donnée n'est revendue.
            </p>
            <div className="flex flex-col sm:flex-row gap-2 mt-3.5">
              <button onClick={() => decide(true)} data-testid="cookie-accept-btn" className="bg-coral text-white px-5 py-2.5 rounded-full text-sm tracking-widest uppercase hover:opacity-90 transition-opacity">
                Tout accepter
              </button>
              <button onClick={() => decide(false)} data-testid="cookie-refuse-btn" className="bg-stone-100 text-stone-700 px-5 py-2.5 rounded-full text-sm tracking-widest uppercase hover:bg-stone-200 transition-colors">
                Continuer sans accepter
              </button>
              <Link to="/cookies" onClick={() => setVisible(false)} data-testid="cookie-policy-link" className="text-sm text-deep-rose underline self-center sm:ml-2">
                En savoir plus
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
